import React from 'react'
import { useRef } from 'react'
import { Helmet } from 'react-helmet'
import { howItWorksCustomRefSection1 } from '../../../Utils/Refs'
import Hero from './Hero/Hero'
import InfoSection from './InfoSection/InfoSection'

const HowItWorksCustom = () => {



    return (
        <section id="how-it-works-custom">

            <Helmet>
                <title>MB&#38;CO | How it works</title>
            </Helmet>

            <Hero />
            <InfoSection />


        </section>
    )
}

export default HowItWorksCustom